import { Skeleton, type SkeletonProps } from '@mui/material';
import clsx from 'clsx';
import * as React from 'react';

const PlaceholderSkeleton = React.memo(function PlacehlderSkeleton({ className, ...rest }: SkeletonProps) {
    return (
        <Skeleton
            className={clsx(
                'bg-transparent bg-gradient-to-r from-[#fbfbfb] to-[#f6f6f6] dark:from-[#333] dark:to-[#2a2a2a]',
                className
            )}
            {...rest}
        />
    );
});

const CommentPlaceholder = React.memo(function CommentPlaceholder() {
    return (
        <div className="mb-[32px] border-b border-b-[#e6e6e6] last:border-b-0 dark:border-b-[#444] sm:mb-[20px] sm:px-[15px]">
            <div className="mb-[20px]">
                <div className="flex flex-row space-x-[14px]">
                    <PlaceholderSkeleton
                        className="h-[32px] w-[32px] rounded-[4px] bg-[#f5f5f5] bg-none dark:bg-[#333] sm:h-[64px] sm:w-[64px]"
                        variant="rectangular"
                        animation="pulse"
                    />
                    <PlaceholderSkeleton className="h-[20px] w-[40%]" variant="rectangular" animation="wave" />
                </div>
                <div className="mt-[12px] flex-1 sm:mt-[-32px] sm:ml-[78px]">
                    <div className="flex flex-col space-y-[7px] sm:space-y-[12px]">
                        <PlaceholderSkeleton className="h-[20px] w-[90%]" variant="rectangular" animation="wave" />
                        <PlaceholderSkeleton
                            className="h-[20px] w-[90%] sm:w-[60%]"
                            variant="rectangular"
                            animation="wave"
                        />
                        <PlaceholderSkeleton className="h-[20px] w-[20%]" variant="rectangular" animation="wave" />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CommentPlaceholder;
